import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { useParams } from "react-router-dom";

import React, {useState,useEffect} from 'react';
import axios from "axios";
import './index.css';
import CodeMirror from '@uiw/react-codemirror';
import { sublime, sublimeInit } from '@uiw/codemirror-theme-sublime';
import { dracula, draculaInit } from '@uiw/codemirror-theme-dracula';
import { javascript } from '@codemirror/lang-javascript';
import {python} from '@codemirror/lang-python'
import { withAuthenticator, Button, Heading, Text, TextField, View } from '@aws-amplify/ui-react';
import { Storage } from "@aws-amplify/storage"

import Split from 'react-split'
import { saveAs } from 'file-saver';
import {Link} from "react-router-dom"

import { Radio } from "@material-tailwind/react";
import Modal from 'react-modal';


const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};


function Editor({ signOut, user }) {

  const { id } = useParams();
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [ebstate, setEbstate] = useState(false)

  function openModal() {
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }

  
  const [period, setPeriod] = useState({
    scale: "day",
    number : 1
  })
  const [code, setCode] = useState("a=0;")
  const [result, setResult] = useState([""]);
  const [projectname, setProjectname] = useState(id);
  const [selection, setSelection] =useState("run")

  useEffect(() => {
    downloadCode(id)
    checkEventBridge()
    // event bridge 상태가 켜져있는지 확인

    // console.log("period",period)
    // console.log("user", user.username)
  }, [])

  const onChange = React.useCallback((value, viewUpdate) => {
    setCode(value)
    // console.log('value:', value);
  }, []);

  const uploadCode = async () => {

    const s3upload = await Storage.put(projectname + ".py", code, {
      level: 'private',
      contentType: 'text/plain'
    });

    // console.log("업로드된 파일명",Storage._pluggables[0]._config.credentials.identityId)

    const zip = require('jszip')();
    zip.file(projectname + ".py", code);

    const zipGen = await zip.generateAsync({type: "blob"}).then(content => {
      return content;
    });

    // console.log("zipGen", zipGen)

    const aa = await Storage.put(projectname + ".zip", zipGen, {
      level: 'private',
      contentType: 'application/zip'
    });

    return Storage._pluggables[0]._config.credentials.identityId;


  }

  const downloadCode = async () => {

    const down = await Storage.get(projectname + ".py", { 
        level: 'private'
    });

    console.log("down",down)
  
    const downCode = await axios.get(down)
    // console.log("downCode",downCode.data)
    setCode(downCode.data)
  }

  const testCode = async () => {
      
    if(selection === "run") {
      const submitResult = await axios.post("http://localhost:3500/python",{code}).then((res)=>{return res.data})
      // console.log("submitResult", submitResult)
      setResult(submitResult.message)
    } else {
      setSelection("run")
    }


  }

  const makeContainer = async () => {

    if(selection === "run") {
      setSelection("deploy")
    }

    // console.log("aa", aa)
  }

  async function siteOut () {
    const out = await signOut({ global: true })
    // console.log("out", out)
    // console.log("window.location", window.location)

    setTimeout(function() {
        if ( window.location.hostname === 'localhost' ) {
            window.location.href='http://localhost:3000';
        } else if ( window.location.hostname === 'quickpoly' ) {
            window.location.href='https://quickpoly.com';
        }
    }, 100);
}

  const handleSubmit = (event) => {
    event.preventDefault();
    alert(`변경된 패스워드: ${event}`);
  };

  const modalhandler = () => {

  }

  const checkEventBridge = async () => {
    const EBstatus = await axios.get(`https://nyzomcdsf8.execute-api.ap-northeast-2.amazonaws.com/production/eventbridgechecker?lambdaName=${user.username}_${id}`)
    // console.log("EBstate", EBstatus)
    // const temp = JSON.parse(EBstatus.data.body)
    // console.log("temp",EBstatus.data.State)

    if(EBstatus.data.State === "ENABLED"){
      setEbstate(true)
    }
    // console.log(JSON.parse(EBstatus.data.body))
  }

  const startHandler = async () => {

    // 최신 코드를 저장하고,
    const identityIdres = await uploadCode()
    // console.log("identityIdres", identityIdres)

    // 코드를 기반으로 람다를 만들고,
    const makeLambda = await axios.post("https://nyzomcdsf8.execute-api.ap-northeast-2.amazonaws.com/production/lambdacontrol", {
      userName: user.username,
      functionName: id,
      identityId: identityIdres
    })

    console.log("makeLambda", makeLambda.data.body)
    
    // const makeConntectEB {
    //   cronExpression : "* * * * *",
    //   targetLambdaName : 
    // }

    // API 로 내용 전송
    // CRON 명령어를 기반으로 -> Eventbridge Rule 을 만들고 -> Lambda 와 연결한다. 다 되면 Success 를 반환


    
  }



  return (
    <div className="App">

    <nav className="bg-white border-gray-900 px-2 sm:px-4 py-2.5 dark:bg-gray-900">
        <div className="flex flex-wrap items-center justify-between mx-auto">
          <a href="https://flowbite.com/" className="flex items-center">
              <span class="self-center text-xl font-semibold whitespace-nowrap dark:text-white">QuickPloy</span>
          </a>        
          <div class="flex md:order-2">
            <Link to="/manage">
            <button type="button" class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-3 md:mr-0 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">내 작업실</button>
            <button data-collapse-toggle="navbar-cta" type="button" class="inline-flex items-center p-2 text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600" aria-controls="navbar-cta" aria-expanded="false">
              {/* <span class="sr-only">Open main menu</span> */}
              <svg class="w-6 h-6" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clip-rule="evenodd"></path></svg>
            </button>
            </Link>
            <button type="button" class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-3 md:mr-0 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800" style={{marginLeft:"20px"}} onClick={siteOut}>로그오프</button>
              <button data-collapse-toggle="navbar-cta" type="button" class="inline-flex items-center p-2 text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600" aria-controls="navbar-cta" aria-expanded="false">
                {/* <span class="sr-only">Open main menu</span> */}
                <svg class="w-6 h-6" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clip-rule="evenodd"></path></svg>
            </button>
          </div>
        </div>
      </nav>


    <main class="main-container editor">

    <Split
      className="split"
      sizes={[60, 40]}
      gutterSize={5}
      >
      
      <div class="code">
        <div class="code-header">
          <div>
            <div class="project-link">
              <span>프로젝트 : </span>
              <input
                name="project-name"
                class="project-name"
                type="text"
                value={projectname}
              />
            </div>
          </div>
          
          <div>
            <button title="Save" class="save" onClick={uploadCode}>
              <span>코드저장</span>
            </button>
            {/* <button title="Save" class="save" onClick={downloadCode} style={{marginLeft:"10px"}}>
              <span>불러오기</span>
            </button> */}
          </div>
        </div>
        <div class="editor-wrapper">
        <CodeMirror
          id="jsCode"
          value={code}
          height="calc(100vh - 90px)"
          theme={dracula}
          keyMap={sublime}
          extensions={[python()]}
          onChange={onChange}
        />
        </div>
      </div>

      <div class="console">
        <div class="console-header">
          <div>
            <h4>Console</h4>
          </div>
          <div>
            <button title="Run" class="run" onClick={testCode}>
              <span>실행</span>
            </button>
            <button title="Run" class="run" onClick={makeContainer} style={{marginLeft:"10px"}}>
              <span>시작</span>
            </button>
          </div>
        </div>
        {selection === "run" ?        
            result[0] === "" ?
            <div>
            <div id="console-logs-empty" class="active">
              <div>
                <p>코드를 실행하고, 로그보기</p>
                <button title="Run" class="run-empty" onClick={testCode}>실행</button>
              </div>
            </div>
            </div>

            :
            <div>
            {result.map((res)=>{
              return <div>{res}</div>
            })}
            </div>
            :
            <>
            <div id="console-logs-empty" class="active">
              <section class="container">

            <div class="container__build">

              <div class="build--stack">
                  주기적 호출
              </div>		

              
              
              <div>
                  <svg height="100px" width="100px"
                    viewBox="0 0 450 450">
                  <g>
                    <g>
                      <path d="M355.232,0l-13.525,13.525l65.821,65.821h-279.17c-52.894,0-95.924,43.031-95.924,95.919v59.633h19.128v-59.633
                        c0-42.343,34.452-76.79,76.796-76.79h279.17l-65.821,65.821l13.525,13.525l88.91-88.91L355.232,0z"/>
                    </g>
                  </g>
                  <g>
                    <g>
                      <path d="M421.053,237.714v59.632c0,42.344-34.452,76.795-76.796,76.795H65.087l65.821-65.825l-13.525-13.525l-88.909,88.914
                        l88.909,88.91l13.525-13.525L65.087,393.27h279.17c52.895,0,95.924-43.031,95.924-95.924v-59.632H421.053z"/>
                    </g>
                  </g>
                  </svg>
                <p style={{marginTop:"20px"}}>
                  {period.number} {period.scale}
                  <span style={{fontSize:"20px", color:"gray", cursor:"pointer"}} onClick={openModal}>  ⚙</span>
                </p>
              </div>
              
            </div>

            <svg viewbox="0 0 10 100" style={{marginLeft:"300px"}}>
              {ebstate ? 
                <line x1="5" x2="5" y1="0" y2="100"/>
                :
                <></>
              }
            </svg>

            <div class="container__deploy">
              <h3>Python</h3>
            </div>
            
            <svg viewbox="0 0 10 5">
            </svg>


            
            <div class="container__sources">

              <div class="sources--markdown" onClick={startHandler}>
                <h3>
                  {!ebstate ? 
                  <>시작</>
                  :
                  <>중단</>
                  }
                </h3>
              </div>

            </div>
          </section>
            </div>
            </>
        }
      </div>
    </Split>

    </main>

    <Modal
        isOpen={modalIsOpen}
        style={customStyles}
        contentLabel="Example Modal"
    >
        <div>I am a modal</div>
        <form>
          <div>
          <input />
          <input />
          </div>
          <button onClick={closeModal}>the modal</button>
        </form>
      </Modal>
    </div>

    
  );
}

export default withAuthenticator(Editor,{
  socialProviders: ['google']
});
